import type { BadmintonGameListItem, BadmintonSessionListItem } from '@/services/badmintonService';

export interface FlatBadmintonGame {
  game: BadmintonGameListItem;
  sessionSlug: string;
  sessionType: string;
  playerFormat: string;
  gameNumber: number;
}

export function flattenBadmintonGames(sessions: BadmintonSessionListItem[]): FlatBadmintonGame[] {
  const result: FlatBadmintonGame[] = [];
  let gameNumber = 1;

  for (const session of sessions) {
    for (const game of session.games ?? []) {
      result.push({
        game: {
          ...game,
          sessionSlug: game.sessionSlug || session.slug,
          sessionType: game.sessionType || session.sessionType,
          playerFormat: game.playerFormat || session.playerFormat,
          scoringType: game.scoringType || session.scoringType,
          rotationFormat: game.rotationFormat || session.rotationFormat,
          sessionNumCourts: game.sessionNumCourts || session.numCourts,
        },
        sessionSlug: session.slug,
        sessionType: session.sessionType,
        playerFormat: session.playerFormat,
        gameNumber: gameNumber++,
      });
    }
  }

  return result;
}

export function countPlayerAppearances(
  sessions: BadmintonSessionListItem[],
  participantId: number
): number {
  let count = 0;
  for (const session of sessions) {
    for (const game of session.games ?? []) {
      const players = [...(game.sideAPlayers ?? []), ...(game.sideBPlayers ?? [])];
      if (players.some((p) => p.participantId === participantId)) {
        count += 1;
      }
    }
  }
  return count;
}

export function hasIncompleteKotcSession(sessions: BadmintonSessionListItem[]): boolean {
  return sessions.some(
    (session) => session.rotationFormat === 'king_of_the_court' && session.status !== 'completed'
  );
}

export function roundGames(round: {
  games?: BadmintonGameListItem[];
  game?: BadmintonGameListItem;
}): BadmintonGameListItem[] {
  if (round.games && round.games.length > 0) return round.games;
  return round.game ? [round.game] : [];
}
